module.exports = __webpack_public_path__ + "img/american-credit-home-slide-10.c4ca9c7.webp";